var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00AF57",
  d: "M43.636 5H20.364c-9.64 0-17.455 7.815-17.455 17.455s7.815 17.454 17.455 17.454h23.272c9.64 0 17.455-7.815 17.455-17.454C61.09 12.814 53.276 5 43.636 5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0EBC5F",
  d: "M45.455 12.273C55.697 12.273 64 20.576 64 30.818s-8.303 18.546-18.545 18.546H32.227L19.552 57.75c-1.404.925-2.105 1.387-2.681 1.425a2.18 2.18 0 0 1-2.04-1.099c-.285-.501-.285-1.342-.285-3.023v-6.123C6.226 47.1 0 39.687 0 30.818c0-10.242 8.303-18.545 18.546-18.545z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "google-chat_svg__a",
  width: 64,
  height: 48,
  x: 0,
  y: 12,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0EBC5F",
  d: "M45.455 12.273C55.697 12.273 64 20.576 64 30.818s-8.303 18.546-18.545 18.546H32.263L17.925 58.78c-1.45.953-3.38-.088-3.38-1.823V48.93C6.226 47.1 0 39.687 0 30.818c0-10.242 8.303-18.545 18.546-18.545z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-chat_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0EBC5F",
  d: "M43.636 5H20.364c-9.64 0-17.455 7.815-17.455 17.455s7.815 17.454 17.455 17.454h23.272c9.64 0 17.455-7.815 17.455-17.454C61.09 12.814 53.276 5 43.636 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#google-chat_svg__b)",
  d: "M43.636 5H20.364c-9.64 0-17.455 7.815-17.455 17.455s7.815 17.454 17.455 17.454h23.272c9.64 0 17.455-7.815 17.455-17.454C61.09 12.814 53.276 5 43.636 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.675 27.042a2.18 2.18 0 0 1 2.916.989l-.003-.005.008.014.075.131c.075.127.199.325.378.572a10.5 10.5 0 0 0 1.742 1.86c1.601 1.345 4.206 2.76 8.209 2.76 4.032 0 6.65-1.362 8.248-2.643a10.2 10.2 0 0 0 1.732-1.765 7 7 0 0 0 .444-.658l.006-.01-.002.005-.003.005a2.182 2.182 0 0 1 3.879 1.999l-1.94-.998a187 187 0 0 1 1.939 1l-.002.002-.002.005-.007.013-.066.12q-.06.107-.163.277c-.139.224-.339.525-.606.877a14.5 14.5 0 0 1-2.479 2.531c-2.297 1.843-5.86 3.604-10.978 3.604-5.146 0-8.723-1.857-11.016-3.784a14.9 14.9 0 0 1-2.47-2.64c-.265-.367-.463-.68-.6-.912a8 8 0 0 1-.209-.375l-.016-.032-.006-.012-.003-.006-.001-.002c0-.001-.001-.002 1.957-.964l-1.958.962a2.18 2.18 0 0 1 .997-2.92"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-chat_svg__b",
  x1: 32,
  x2: 32,
  y1: 5,
  y2: 39.909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#94D4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#78C9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#01AE58",
  stopOpacity: 0
})))));
export default SvgGoogleChat;